import type { PodBrand } from '@/types/pod'
import { env } from '@/lib/env'
import { oxydisePod } from '@pods/oxydise/config'
import { chamberflowPod } from '@pods/chamberflow/config'
import { foredeskPod } from '@pods/foredesk/config'
import { hallsPod } from '@pods/halls/config'
import { inspectvoicePod } from '@pods/inspectvoice/config'
import { playsafetyPod } from '@pods/playsafety/config'
import { rezabondPod } from '@pods/rezabond/config'
import { rezabondTrainingPod } from '@pods/rezabond-training/config'
import { swsteelPod } from '@pods/swsteel/config'
import { ctcPod } from '@pods/ctc/config'
import { ftsPod } from '@pods/fts/config'
import { jncPod } from '@pods/jnc/config'
import { csbPod } from '@pods/csb/config'
import { kernowPod } from '@pods/kernow/config'
import { kelvoDemoPod } from '@pods/kelvo-demo/config'

/**
 * Pod registry. The engine resolves which pod to serve at build time from
 * VITE_ACTIVE_POD. Onboarding a new client adds one entry here and one pod
 * folder — no engine logic changes.
 */
const registry: Record<string, PodBrand> = {
  oxydise: oxydisePod,
  chamberflow: chamberflowPod,
  foredesk: foredeskPod,
  halls: hallsPod,
  inspectvoice: inspectvoicePod,
  playsafety: playsafetyPod,
  rezabond: rezabondPod,
  'rezabond-training': rezabondTrainingPod,
  swsteel: swsteelPod,
  ctc: ctcPod,
  fts: ftsPod,
  jnc: jncPod,
  csb: csbPod,
  kernow: kernowPod,
  'kelvo-demo': kelvoDemoPod,
}

/** Every registered browser pod, for the registry-agreement tests. */
export function allPodBrands(): PodBrand[] {
  return Object.values(registry)
}

export function getActivePod(): PodBrand {
  const pod = registry[env.VITE_ACTIVE_POD]
  if (!pod) {
    throw new Error(
      `Unknown pod "${env.VITE_ACTIVE_POD}". Available pods: ${Object.keys(registry).join(', ')}`,
    )
  }
  return pod
}
